import Vue from "vue";
import Vuex from "vuex";

import app from "./app";
import home from "./home";
import billing from "./billing";
import downpayment from "./downpayment";
import page from "./page";
import settings from "./settings";
import vat from "./vat";
import models from "./models";
import recurring from "./recurring";
import tags from "./tags";
import guest from "./guest";
import onboarding from "./onboarding";
import langs from "./langs";
import contacts from "@/store/contacts";

Vue.use(Vuex);

const store = new Vuex.Store({
	modules: {
		app,
		home,
		billing,
		downpayment,
		page,
		settings,
		vat,
		models,
		recurring,
		tags,
		guest,
		onboarding,
		langs,
		contacts
	}
});

export { store };
